export interface UpdateSimpleMagazineRequest {
  id: number
  volume: string
  volumeNumber: string
  volumeTotal: string
  dateLabel: string
  dateIssue: string
  specialType: string
  materialFormat: string
  continuationStatus: string
  magazineCode: string
  classNo: string
  edition: string
  publicationYear: string
  price: string
  displayPrice: string
  size: string
  page: string
  imageFile: string
  _imageFileDelete: boolean
  revision: number
}

export function UpdateSimpleMagazineRequestToJSON(
  value: UpdateSimpleMagazineRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    volume: value.volume !== '' ? value.volume : undefined,
    volume_number: value.volumeNumber !== '' ? value.volumeNumber : undefined,
    volume_total: value.volumeTotal !== '' ? value.volumeTotal : undefined,
    date_label: value.dateLabel !== '' ? value.dateLabel : undefined,
    date_issue: value.dateIssue !== '' ? value.dateIssue : undefined,
    special_type: value.specialType !== '' ? value.specialType : undefined,
    material_format:
      value.materialFormat !== '' ? value.materialFormat : undefined,
    continuation_status:
      value.continuationStatus !== '' ? value.continuationStatus : undefined,
    magazine_code: value.magazineCode !== '' ? value.magazineCode : undefined,
    class_no: value.classNo !== '' ? value.classNo : undefined,
    edition: value.edition !== '' ? value.edition : undefined,
    publication_year:
      value.publicationYear !== '' ? value.publicationYear : undefined,
    price: value.price !== '' ? value.price : undefined,
    display_price: value.displayPrice !== '' ? value.displayPrice : undefined,
    size: value.size !== '' ? value.size : undefined,
    page: value.page !== '' ? value.page : undefined,
    image_file: value.imageFile !== '' ? value.imageFile : undefined,
    _image_file_delete: value._imageFileDelete,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
